import {filter, map, take} from 'rxjs/operators';
import {PILOT_CONTRACT_TAKER_FEE} from '@px/const/data-config';
import type {Observable} from 'rxjs';

export const contractUtil = {
  createContract$(contracts$: Observable<ContractPair[]>, symbol: string): Observable<ContractPair> {
    return contracts$.pipe(
      map((contracts) => contracts.find((contract) => contract.symbol === symbol)),
      filter(Boolean),
      take<ContractPair>(1)
    );
  },
  isPerpetualContract(type: TradeType) {
    return type === 'Perpetual';
  },
  findContract(contracts: ContractPair[], symbol: string): ContractPair {
    return contracts.find((contract) => contract.symbol === symbol);
  },
  isPerpetualV2Contract(type: TradeType) {
    return type === 'PerpetualV2';
  },
  isPilotContractV1(type: TradeType) {
    return type === 'PerpetualPilot';
  },
  isPilotContract(type: ContractPerpType) {
    return type === 'Pilot';
  },
  isNormalContract(type: ContractPerpType) {
    return type === 'Normal' || !type;
  },
  isPerpetual(type: TradeType) {
    return ['Perpetual', 'PerpetualV2', 'PerpetualPilot'].includes(type);
  },
  isSupportHedgeMode(type: TradeType) {
    return this.isPerpetualV2Contract(type) || this.isPilotContractV1(type);
  },
  filterPilotContract(contracts: ContractPair[]) {
    return contracts.filter((o) => this.isPilotContract(o.perpProductSubType));
  },
  filterNormalContract(contracts: ContractPair[]) {
    return contracts.filter((o) => this.isNormalContract(o.perpProductSubType));
  },
  getCrossRiskUnitKey(settleCurrency) {
    return settleCurrency + 'Invalid';
  },
  getDefaultTakerFeeRate(contracts: ContractPair, defaultTakerFeeRateEr) {
    return this.isPilotContract(contracts.perpProductSubType) ? PILOT_CONTRACT_TAKER_FEE : defaultTakerFeeRateEr;
  },
};
